import { useEffect, useState } from "react";
import axios from "axios";

const apiUrl = "https://elcobradorleague.com/api";

export const usePlayerArmyLeaderboard = (playerId, idleague) => {
  const [leaderboard, setLeaderboard] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!idleague) return;

    const fetchLeaderboard = async () => {    
      try {   
        let url = `${apiUrl}/api.php?endpoint=player_army_leaderboard`;
        if (playerId && playerId !== 0) {
          url += `&playerId=${playerId}`;
        }
        if (idleague && idleague !== 0) {
          url += `&idleague=${idleague}`; 
        }

        console.log("Fetching:", url);

        const res = await axios.get(url);
        setLeaderboard(res.data);
      } catch (err) {
        console.error("Error fetching leaderboard:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchLeaderboard();
  }, [playerId, idleague]);

  console.log("Leaderboard:", leaderboard);
  console.log("array", Array.isArray(leaderboard));

  return { leaderboard, loading, error };
};